import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.tokenValue;
  const translate = inject(TranslateService);

  if (token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'X-Locale': translate.getCurrentLang(),
        'X-Locale-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        'X-Client-Locale': translate.getCurrentLang(),
      },
    });
    return next(cloned);
  }

  return next(req);
};
